function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import _ from 'lodash';
import { htmlToReact } from '../utils';
import SubscribeForm from './SubscribeForm';

var Subscribe =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Subscribe, _React$Component);

  function Subscribe() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Subscribe.prototype;

  _proto.render = function render() {
    return React.createElement("section", {
      className: "subscribe"
    }, React.createElement("div", {
      className: "inner"
    }, React.createElement("h2", {
      className: "subscribe-title"
    }, _.get(this.props, 'pageContext.site.data.subscribe.title')), React.createElement("p", {
      className: "subscribe-text"
    }, htmlToReact(_.get(this.props, 'pageContext.site.data.subscribe.content'))), React.createElement(SubscribeForm, this.props)));
  };

  return Subscribe;
}(React.Component);

export { Subscribe as default };